import { useState, useCallback } from "react";
import { getAPIN8N } from "@/services/Api/n8nApiConfig";

export function useRefund() {
  const REFUND_API = getAPIN8N("d897b563-f2d5-4792-a874-8a48309bceef");
  const REFUND_API_LETTER = getAPIN8N("bf59f61e-0c04-41df-a2fe-dc58ac023756");
  const baseUrlPatch = "v3/charges/solicitation-partial-refund";
  const baseUrlPatchLetter = "v2/app/charges";
  const baseUrlGet = "v3/charges/verify-partial-refund";
  const [responseVerify, setResponseVerify] = useState<any>(null);

  const verifyRefundBalance = useCallback(async (uuidCharge: String) => {
    try {
      const response = await REFUND_API.get(`${baseUrlGet}/${uuidCharge}`);
      setResponseVerify(response?.data);
      return response?.data;
    } catch (error) {
      console.error("Erro ao verificar saldo de estorno:", error);
      throw error;
    }
  }, [baseUrlGet]);

  const solicitationRefund = useCallback(async (uuidCharge: String, data: any) => {
    try {
      const response = await REFUND_API.patch(`${baseUrlPatch}/${uuidCharge}`, data);
      
      await verifyRefundBalance(uuidCharge);
      
      return response;
    } catch (error) {
      console.error("Erro ao solicitar estorno:", error);
      throw error;
    }
  }, [baseUrlPatch, verifyRefundBalance]);

  const solicitationRefundLetter = useCallback(async (uuidCharge: String) => {
    try {
      const response = await REFUND_API_LETTER.post(`${baseUrlPatchLetter}/${uuidCharge}/refund-letter`);
      return response?.data;
    } catch (error) {
      console.error("Erro ao solicitar carta de estorno:", error);
      throw error;
    }
  }, [baseUrlPatch]);
  return {
    solicitationRefund,
    verifyRefundBalance,
    solicitationRefundLetter,
    responseVerify,
  };
}
